import { render } from "./Main.vue?vue&type=template&id=1f17d678"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\haqua\\Documents\\vue\\rebrand\\feedback-page-resell\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__